SectionProfile.EventBase = Class(
	/**
	 * @lends {SectionProfile.EventBase#}
	 */
	{
		__NAME: 'SectionProfileEventBase',

		bodyClass: 'small-nav grey',

		TOP_BAR: false,

		eventId: null,
		eventSlug: null,
		/** @type {DR.events.struct.Event} */
		event: null,

		route: function(){
			const eventId = this.url.before;
			if( isNaN(eventId) ){
				this.eventSlug = eventId;
			} else{
				this.eventId = parseInt(eventId);
			}
		},

		draw: function(){
			this._drawBase();
		},

		_onAuthError: function(){
			Section.navigate(
				D.url('/sign-in?redirect=' + encodeURIComponent(D.url('/profile/event/' + this.event.seoTitle)))
			);
		},

		_drawBase: function(){
			if( !D.ID ){
				this._onAuthError();
				this.ready();
				return;
			}
			if( !this.eventId && !this.eventSlug ){
				this.ready();
				Section.navigate(D.url('/profile'));
				return;
			}

			this._mainNode = mkE({
				tag: 'div',
				id: 'profile',
				className: 'event container ' + (this.TOP_BAR ? 'topbar' : ''),
				els: [
					this._sidebarNode = mkE({
						tag: 'div',
						className: 'profile-sidebar'
					}),
					this._container = mkE({
						tag: 'div',
						className: 'profile-container',
						els: [
							this._content = mkE({
								tag: 'div',
								className: 'profile-content'
							})
						]
					})
				]
			}).append(this.layout.ct());

			this._mGetEvent = new DR.events.Get();
			this._mGetEvent.onLoad = this._mGetEventRe;
			this._mGetEvent.onError = this._mGetEventErr;
			this._mGetEvent.select = [
				new DR.events.select.Event().id().title().description().startTime().endTime().maxPlayers().minPlayers().hasImage().image()
					.status().ticket().registrationDate().showResults().hasTeam().seoTitle().settings(),
				new DR.roadgames.select.Image().medium()
			];
			this.apiCall.addMethod(this._mGetEvent);

			this._draw();

			this.apiCall.onLoad = this._onApiCallRe;
			this.apiCall.call({eventId: this.eventId, eventSeoTitle: this.eventSlug});
		},

		_mGetEventRe: function(){
			this.event = this._mGetEvent.re;
			this.eventId = this._mGetEvent.re.id;
			this.eventSlug = this._mGetEvent.re.seoTitle;
		},

		_mGetEventErr: function(){
			this.event = null;
			this.eventId = 0;
			this.eventSlug = '';
		},

		_onApiCallRe: function(){
			if( !this.eventId ){
				this.ready();
				Section.navigate(D.url('/profile'));
				return;
			}
			this._ready();
			this.ready();
		},

		_forceStickers: function (  ) {
			if( !this.team || !this.team.captain ) {
				return false;
			}
			return this.event.status === DR.events.struct.Event.STATUS_REGISTRATION && this.event.settings.hasStickers && this.team.stickers.freeStickers === 0 && this.team.captain.id === D.ID;
		},

		_drawSidebar: function(options){
			options = options || {};
			mkE({
				tag: 'a',
				className: 'profile-back',
				href: D.url('/profile/events'),
				text: D.Lang.get('profile.menu.back')
			}).append(this._sidebarNode);

			const webImage = in_array(this.event.seoTitle, ['kurzeme-2019', 'vidzeme-2019', 'zemgale-2020', 'roadgames-urban-centrs', 'roadgames-urban-agenskalns']);
			const showDate = this.event.settings.type !== 'anytime';
			mkE({
				tag: 'div',
				className: 'profile-sidebar-event ' + this.event.seoTitle,
				els: [
					{
						tag: 'div',
						className: 'image',
						style: {
							backgroundImage: this.event.image && !webImage ? 'url(' + this.event.image.medium + ')' : ''
						}
					},
					{
						tag: 'div',
						className: 'title',
						els: [
							options.purchase ? {
								tag: 'h4',
								text: this.event.title
							} : {
								tag: 'h4',
								els: [
									{
										tag: 'a',
										href: D.url('/event/' + this.event.seoTitle),
										text: this.event.title
									}
								]
							}
						]
					},
					this.event.settings.type !== 'anytime' ? {
						tag: 'div',
						className: 'country-date',
						els: [
							/*{
								tag: 'div',
								className: 'country',
								els: [
									// {
									// 	tag: 'span',
									// 	className: 'flag cc-' + this.event.country
									// },
									D.Lang.get('iso.countries.' + this.event.country),
									showDate ? {
										tag: 'span',
										text: ','
									} : ''
								]
							},*/
							{
								tag: 'div',
								className: 'date',
								text: this.event.settings.hasUnknownDate ? D.Lang.get('profile.games.soon') : D.Date.formatDateRange(this.event.startTime, this.event.endTime, 'j. %F, H:i', 'H:i', ' - ')
							}
						]
					} : null
				]
			}).append(this._sidebarNode);
		},

		_drawTabs: function(){
			let menuItems = [];
			if( !this._forceStickers() ) {
				menuItems.push({
					name: 'team',
					url: D.url('/profile/event/' + this.eventSlug),
					caption: D.Lang.get('profile.menu.' + (this.event.maxPlayers > 1 ? 'team' : 'info'))
				});
			}
			if( this.event.hasTeam ){
				if( this.event.showResults ){
					menuItems.push({
						name: 'results',
						url: D.url('/profile/event/' + this.eventSlug + '/results'),
						caption: D.Lang.get('profile.menu.results')
					});
					if( this.event.settings.hasCrazyWolves ){
						menuItems.push({
							name: 'groupie',
							url: D.url('/profile/event/' + this.eventSlug + '/groupie'),
							caption: D.Lang.get('profile.menu.groupie')
						});
					}
				} else if( this.event.status === 'registration' && this.event.settings.hasStickers ){
					menuItems.push({
						name: 'stickers',
						url: D.url('/profile/event/' + this.eventSlug + '/stickers'),
						caption: D.Lang.get('profile.menu.stickers')
					});
				}
			}
			this._tabs = new T.MainTabs({
				items: menuItems,
				active: this.name,
				onclick: D.closure(this, function(item, e){
					if (existsClassName(D.event(e).target.parentElement, 'active')) {
						if (menuItems.length > 1) {
							toggleClassName(this._tabs.node, 'expanded');
						}
						e.preventDefault();
						e.stopPropagation();
						return false;
					}
				})
			});
			this._tabs.prepend(this._container);
		},

		_ready: function(){
		},

		/** @abstract */
		_draw: function(){
		} // override
	},
	Section
);

SectionProfile.Event = Class(
	/**
	 * @lends {SectionProfile.Event#}
	 */
	{
		__NAME: 'SectionProfileEvent',

		name: 'team',

		route: function(){
			const p = this.url.shift();
			if( isNaN(p) ){
				this.eventSlug = p;
			} else{
				this.eventId = p;
			}
			switch( this.url.current ){
				case 'create':
					return new SectionProfile.Event.Create();
				case 'stickers':
					return new SectionProfile.Event.Stickers();
				case 'groupie':
					return new SectionProfile.Event.Groupie();
				case 'results':
					return new SectionProfile.Event.Results();
				case 'success':
					return new SectionProfile.Event.CreateSuccess();
			}
		},

		_draw: function(){
			this._mGetMyData = new DR.users.GetMyData();
			this._mGetMyData.onLoad = this._mGetMyDataRe;
			this._mGetMyData.select = [
				new DR.users.select.MyData().user().team(),
				new DR.teams.select.Team().captain().hasImage().id().hasImage().image().title().users().invites().canChangeImage().canChangeTitle().canChangeUsers().stickers().maxPlayers(),
				new DR.users.select.User().id().name().surname().image().hasImage(),
				new DR.roadgames.select.Image().medium()
			];
			this.apiCall.addMethod(this._mGetMyData);
		},

		_mGetMyDataRe: function(){
			this.user = this._mGetMyData.re.user;
			this.team = this._mGetMyData.re.team;
		},

		_ready: function(){
			if( !this.user ){
				this._onAuthError();
				this.ready();
				return;
			}
			if( !this.team ){
				this.ready();
				Section.navigate(D.url('/profile/event/' + this.event.seoTitle + '/create'));
				return;
			}

			if( this._forceStickers() ) {
				this.ready();
				const get = new Get('/profile/event/' + this.event.seoTitle + '/stickers');
				if( this.url.get.is('pmt-success') ) {
					get.add('pmt-success');
				}
				Section.navigate(get.toUrl());
				return;
			}

			this._drawTabs();
			this._drawSidebar();

			mkE({
				tag: 'div',
				className: 'profile-download-wrap',
				els: [
					{
						tag: 'div',
						className: 'profile-download',
						els: [
							{
								tag: 'div',
								className: 'profile-download-info',
								els: [
									{
										tag: 'div',
										className: 'profile-download-success'
									},
									{
										tag: 'div',
										className: 'profile-download-text',
										text: D.Lang.get('profile.team.download.text' + (this.team.captain.id === D.ID ? 'Captain' : ''))
									}
								]
							},
							{
								tag: 'div',
								className: 'profile-download-links',
								els: [
									{
										tag: 'div',
										className: 'profile-download-caption',
										text: D.Lang.get('profile.team.download.caption')
									},
									{
										tag: 'div',
										className: 'profile-download-buttons',
										els: [
											new T.Download()
										]
									}
								]
							}
						]
					}
				]
			}).prepend(this._content);

			if( this.url.get.is('pmt-success') ){
				let success = [
					D.Lang.get('profile.team.purchase.success')
				];
				if( this.team.invites.length ){
					success.push({
						tag: 'br'
					});
					success.push(D.Lang.get('profile.team.purchase.invitesSent'));
				}
				let successMessage = mkE({
					tag: 'div',
					className: 'message',
					els: [
						T.success(success)
					]
				}).prepend(this._content);

				if (this.url.get.is('id')) {
					let popupPoll = new T.PopupPoll(DR.popuppolls.GetPoll.TYPE_FIRST_WEB, {
						apiCallParams: {
							paymentId: Number(this.url.get.v('id'))
						}
					});
					D.insertAfter(popupPoll.node, successMessage);
				}
			}

			new T.TeamEditor(this.event, this.user, this.team).append(this._content);
		}
	},
	SectionProfile.EventBase
);
